import Vue from "vue";
import VueI18n from "vue-i18n";
import EN from "./lang/en-US";
import CN from "./lang/zh-CN";
Vue.use(VueI18n);
const DEFAULT_LANG = "cn";
const LOCALE_KEY = "orderLocaleLanguage";
const locales = {
  en: EN,
  cn: CN,
  zh: CN, // 兼容旧的 cn
};
// const i18n=new VueI18n({
// 　　locale:DEFAULT_LANG,
//     // fallbackLocale:DEFAULT_LANG,
// 　　messages:locales
// });
export const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  // fallbackLocale:DEFAULT_LANG,
  messages: locales,
});
export const setup = (lang) => {
  if (!lang) {
    lang = localStorage.getItem(LOCALE_KEY);
    if (!locales[lang]) {
      lang = DEFAULT_LANG;
    }
  }
  localStorage.setItem(LOCALE_KEY, lang);
  Object.keys(locales).forEach(function (lang) {
    document.body.classList.remove(`lang-${lang}`);
  });
  document.body.classList.add(`lang-${lang}`);
  document.body.setAttribute("lang", lang);
  i18n.locale = lang; // Vue.config.lang=lang;
};
// setup();
// window.i18n = i18n



// WEBPACK FOOTER //
// ./src/locales/index.js